import React, { useState } from 'react';
import rest from '../../data/restWrapper';
import translate from '@data/translations';
// import { ReactComponent as Logo } from '../../assets/custom/logo/logo.svg';
import { ReactComponent as LogoOnly } from '../../assets/custom/logo/logo_only.svg';

async function registerUser(email: string, password: string) {
    return await rest('/createFirstUser', 'POST', { email, password });
}

interface LandingProps {
    onCancel?: Function;
}

interface FormDataInterface {
    email: string;
    password: string;
    passwordRepeat: string;
}
function Landing(props: LandingProps) {
    const [validationOrErrorNote, setValidationOrErrorNote] = useState('' as string);
    // const [inputsReady, setInputsReady] = useState(false as boolean);
    const [formData, setFormData] = useState({} as FormDataInterface);

    const onChangeHandler = (e: any) => {
        let _formData: any = { ...formData };
        _formData[e.target.name] = e.target.value;
        setFormData(_formData);
    };

    const validateEmail = () => {
        let isValid = true;
        // eslint-disable-next-line
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(formData.email)) {
            isValid = false;
            setValidationOrErrorNote('Email not valid.');
        }
        return isValid;
    };

    const validatePasswords = () => {
        let isValid = true;
        if (formData?.password !== formData?.passwordRepeat) {
            isValid = false;
            setValidationOrErrorNote('Password input are not matched.');
        } else if (!formData?.password || formData?.password?.length < 6) {
            isValid = false;
            setValidationOrErrorNote('Password must be at least 6 characters long.');
        }
        if (isValid) {
            setValidationOrErrorNote('');
        }
        return isValid;
    };

    const submitForm = async (e: any) => {
        e.preventDefault();
        if (validatePasswords() && validateEmail()) {
            try {
                await registerUser(formData.email, formData.password);
                //@ts-ignore
                window.location = '/';
            } catch (err: any) {
                setValidationOrErrorNote(err.message);
            }
        }
    };

    return (
        <div className="login-wrapper">
            <div className="login-background">
                <div className="login-logo">
                    <div className='logo'></div>
                </div>
            </div>
            <div className="login-form-wrapper">
                <div className="login-bg-white">
                    <div className="form-wrapper">
                        <div className="form-container">
                            <div className="logo-only">
                                <LogoOnly />
                            </div>
                            <div className="mt-16p mb-4p h3-bold">{translate('Welcome!')}</div>
                            <div className="p-text">{translate('Please enter fields for register.')}</div>
                            <br />
                            <div className="">
                                <label className="bold-letters">{translate('Email')}</label>
                                <div className="input-container mb-4p" style={{ width: '100%' }}>
                                    <input
                                        value={formData.email}
                                        autoComplete="off"
                                        type="email"
                                        name="email"
                                        placeholder={translate('Email')}
                                        className="input-field "
                                        onChange={(e) => onChangeHandler(e)}
                                        onBlur={validateEmail}
                                    />
                                </div>
                                <label className="bold-letters mt-16p">{translate('Password')}</label>
                                <div className="input-container mb-4p" style={{ width: '100%' }}>
                                    <input
                                        value={formData.password}
                                        type="password"
                                        autoComplete="off"
                                        name="password"
                                        placeholder={translate('Password')}
                                        className="input-field"
                                        onChange={(e) => onChangeHandler(e)}
                                    />
                                </div>
                                <label className="bold-letters mt-16p">{translate('Repeat password')}</label>
                                <div className="input-container mb-4p" style={{ width: '100%' }}>
                                    <input
                                        value={formData.passwordRepeat}
                                        type="password"
                                        autoComplete="off"
                                        name="passwordRepeat"
                                        placeholder={translate('Repeat password')}
                                        className="input-field"
                                        onChange={(e) => onChangeHandler(e)}
                                        onBlur={validatePasswords}
                                    />
                                </div>
                                <br />
                                <div className="button-primary " onClick={submitForm}>
                                    {translate('Register')}
                                </div>
                                <div
                                    className="button-secondary mt-8p"
                                    onClick={() => {
                                        if (props.onCancel) {
                                            props.onCancel();
                                        }
                                    }}
                                >
                                    {translate('Cancel')}
                                </div>
                                <br />
                                {validationOrErrorNote !== '' ? (
                                    <div className="alert-box mt-8p" role="alert">
                                        {validationOrErrorNote}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                    <div className="p-text-small mt-8p" style={{ textAlign: 'center' }}>
                        {translate('Having trouble logging in? Contact us at info@pimatico.com')}
                    </div>
                </div>
                <div className='p-text-small copyright'>&copy;{" "}{translate("2023 Copyright HOLOGIC - All Rights Reserved")}</div>
            </div>
        </div>
    );
}

export default Landing;
